import { render, staticRenderFns } from "./Modulecard.vue?vue&type=template&id=591675c8&"
import script from "./Modulecard.vue?vue&type=script&lang=js&"
export * from "./Modulecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports